/*function getContents(testName, ext) {
    return $.ajax({
        type: "GET",
        url: testName + '.' + ext,
        dataType: "text",
        async: false
        }).responseText;
}*/

function getContentsWithCallback(testName, ext, callback) {
    $.ajax({
        type: "GET",
        url: testName + '.' + ext,
        dataType: "text",
        async: true
        }).done(function (data) { callback(data); });
}

function s4() {
  return Math.floor((1 + Math.random()) * 0x10000)
             .toString(16)
             .substring(1);
};

function guid() {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
         s4() + '-' + s4() + s4() + s4();
}
